import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsHeaderOverlayDisabled } from "../store/slices/layout";
export var useHeaderOverlayEffect = function useHeaderOverlayEffect(ref, overlayDisabled, backdrop) {
  useEffect(function () {
    var el = ref.current;
    if (!el) return undefined;
    if (overlayDisabled) {
      el.style.removeProperty('backdrop-filter');
      el.style.removeProperty('-webkit-backdrop-filter');
      el.style.background = 'transparent';
    } else if (backdrop) {
      el.style.setProperty('backdrop-filter', 'blur(30px)');
      el.style.setProperty('-webkit-backdrop-filter', 'blur(30px)');
    }
    return function () {
      el.style.removeProperty('backdrop-filter');
      el.style.removeProperty('-webkit-backdrop-filter');
    };
  }, [ref, overlayDisabled, backdrop]);
};
export var useOverlayEventListener = function useOverlayEventListener() {
  var dispatch = useDispatch();
  useEffect(function () {
    var handleEvent = function handleEvent(e) {
      var event = e;
      dispatch(setIsHeaderOverlayDisabled(event.detail.disabled));
    };
    window.addEventListener('overlayDisabledChange', handleEvent);
    return function () {
      return window.removeEventListener('overlayDisabledChange', handleEvent);
    };
  }, []);
};